import { render } from "./AssProfile.vue?vue&type=template&id=a4635b28&scoped=true"
import script from "./AssProfile.vue?vue&type=script&lang=js"
export * from "./AssProfile.vue?vue&type=script&lang=js"

import "./AssProfile.vue?vue&type=style&index=0&id=a4635b28&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4635b28"]])

export default __exports__